module.exports = __webpack_public_path__ + "img/about-image.86e46429.jpg";